export interface SerialNumberSpec {
  readonly regex: string
}

export const toRegexp: (spec: SerialNumberSpec) => RegExp = (spec: SerialNumberSpec) =>
  new RegExp(spec.regex)
